import { Card, ListGroup } from "react-bootstrap";
import React from "react";

interface IPricingCardProps {
  title: string;
  price: string;
  description: string;
}

function PricingCard({ title, price, description }: IPricingCardProps) {
  return (
    <Card
      className="m-2 rounded-3 shadow-sm border-primary"
      style={{ minWidth: "360px" }}
    >
      <Card.Header className="py-3 bg-primary border-primary text-white">
        <h4 className="my-0 fw-normal" style={{ fontSize: "1.2rem" }}>
          {title}
        </h4>
      </Card.Header>
      <Card.Body>
        <ListGroup variant="flush" className="my-2">
          <ListGroup.Item>{description}</ListGroup.Item>
          <ListGroup.Item>{price} €</ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
}

export default PricingCard;
